module.exports = __webpack_public_path__ + "img/profile-close.8e9456ca.svg";